import { useEffect } from 'react';
import store from 'features/store';

import './Loader.scss';

export const Loader = () => {

    useEffect(() => {
        store.dispatch({ type: 'FOOTER', payload: false });

        return () => {
            store.dispatch({ type: 'FOOTER', payload: true });
        };
    }, []);

    return (
        <div className="app-loader d-flex align-items-center justify-content-center">
            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
        </div>
    );
};